/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.iaCorrections.ts
 *
 * Messages ajoutés par les corrections IA du 2026-10-04 : cartes du bloc de
 * recommandations (raisons de la sélection par règles, source « règles »),
 * nouvelle demande de consentement quand le texte a changé de version.
 * Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement, de lieu, ni
 * « salon », « atelier », « exposant » écrits en dur ; le vocabulaire vient
 * des jetons {lexWorkshop...} et {eventType...}.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesIaCorrectionsFr: Record<string, string> = {
  // ── Bloc de recommandations (Mon espace) ────────────────────────────────
  'iaCorrections.reco.titre': '{lexWorkshopPluralCap} conseillé{lexWorkshopAgrPlural} pour vous',
  'iaCorrections.reco.source.regles': 'Selon votre profil',
  'iaCorrections.reco.raison.interets': 'En lien avec vos centres d’intérêt.',
  'iaCorrections.reco.raison.secteur': 'En lien avec votre secteur.',
  'iaCorrections.reco.raison.bientot': 'Prochainement au programme, encore accessible.',
  'iaCorrections.reco.mention':
    'Suggestions produites automatiquement à partir de votre profil et de vos réponses. Elles ne remplacent pas le programme complet.',
  'iaCorrections.reco.programme': 'Voir tout le programme',

  // ── Nouvelle demande de consentement ────────────────────────────────────
  'iaCorrections.consent.nouvelleVersion':
    'Le texte ci-dessous a changé : il précise désormais que le texte de votre CV, ou sa photo, peut être transmis. Tant que vous ne l’avez pas accepté de nouveau, plus rien n’est envoyé à l’IA.',
};
